import { NO_GATEWAY_ASSIGNED } from './constants';

export const isGatewayNotAssigned = (gatewayCurrentStatus: string): boolean => (
  gatewayCurrentStatus === NO_GATEWAY_ASSIGNED
);
